import React from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import ReportRow from "./ReportRow";

const ReportsHistoryTable = ({ reports, domain }) => {
  return (
    <Table className="ant-table-thead">
      <Thead className="ant-table-thead">
        <Tr>
          <Th className="ant-table-cell">Report Type</Th>
          <Th className="ant-table-cell">Start Date</Th>
          <Th className="ant-table-cell">End Date</Th>
          <Th className="ant-table-cell">Format</Th>
          <Th className="ant-table-cell">Created At</Th>
          <Th className="ant-table-cell">Actions</Th>
        </Tr>
      </Thead>
      {reports.length !== 0 ? (
        <Tbody className="ant-table-tbody">
          {reports.map((report) => {
            return (
              <ReportRow
                report={report}
                key={report._id}
                currentDomainId={domain._id}
              />
            );
          })}
        </Tbody>
      ) : (
        <Tbody className="ant-table-tbody">
          <Tr className="ant-table-row ant-table-row-level-0">
            <Td
              className="ant-table-cell"
              colSpan="4"
              style={{ textAlign: "center", fontWeight: "bold" }}
            >
              No Report Found!
            </Td>
          </Tr>
        </Tbody>
      )}
    </Table>
  );
};

export default ReportsHistoryTable;
